import Box from "@mui/material/Box";
import MuiModal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import PropTypes from "prop-types";
import React from "react";

export const ModalActions = ({ sx, ...props }) => {
  return <Stack direction="row" spacing={1} {...props} sx={{ justifyContent: "flex-end", ...sx }} />;
};

ModalActions.propTypes = {
  sx: PropTypes.shape(),
};

const Modal = (props) => {
  const { children = null, onClose, size = null, alignItems = "center", sx = {}, ...others } = props;

  return (
    <MuiModal onClose={onClose} sx={sx} {...others}>
      <Box
        sx={{
          position: "absolute",
          top: alignItems === "flex-start" ? "56px" : "50%",
          left: "50%",
          transform: alignItems === "flex-start" ? "none" : "translate(-50%, -50%)",
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "100vh",
        }}
        onClick={onClose}
      >
        <Paper
          onClick={(e) => e.stopPropagation()}
          sx={(theme) => ({
            width: `${size && theme.breakpoints.values[size] ? `${theme.breakpoints.values[size]}px` : "auto"}`,
            maxWidth: `100%`,
            maxHeight: "95vh",
            overflow: "auto",
          })}
        >
          <Box sx={{ p: 2 }}>{children}</Box>
        </Paper>
      </Box>
    </MuiModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  alignItems: PropTypes.oneOf(["flex-start", "center"]),
};

export default Modal;
